import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { LocationCodesViewStore } from '../../stores/LocationCodesViewStore'

interface IProps {
  viewStore: LocationCodesViewStore
}

export const LocationCodeHeader: FC<IProps> = observer(({ viewStore }) => {
  const { t } = useTranslate()
  const title = t('unLocationCodes', 'UN Location codes')
  const breadcrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: title,
    },
  ]

  return (
    <Header
      title={title}
      breadcrumbs={breadcrumbs}
      rightRenderOption={
        <Button
          sx={{ flex: 'none' }}
          variant='contained'
          onClick={() => {
            viewStore.toggleFormDialog(true)
          }}
          data-cy='add-new-location-code-btn'
        >
          {t('createLocationCode', 'Create location code')}
        </Button>
      }
    />
  )
})
